module.exports = __webpack_public_path__ + "8ad71cfa730e04de1e7eedfac5ad9c7c.png";